import React, { FC } from 'react';
import { Chip, InputAdornment, OutlinedInput } from '@material-ui/core';
import { MAX_INPUT_LENGTH } from '../../../../constants/common';
import { ComposerProps } from 'react-web-gifted-chat';

const CustomComposer: FC<ComposerProps> = (props) => {
  const {
    text,
    onTextChanged,
    multiline,
    placeholder,
    textInputAutoFocus,
    textInputProps,
  } = props;

  return (
    <OutlinedInput
      value={props?.text ?? ''}
      inputProps={textInputProps}
      onChange={(e) => {
        onTextChanged && onTextChanged(e?.target?.value ?? '');
      }}
      endAdornment={
        !!props.text?.length && (
          <InputAdornment position="end">
            <Chip
              size="small"
              label={`${text?.length ?? 0} / ${MAX_INPUT_LENGTH}`}
            />
          </InputAdornment>
        )
      }
      style={{ flex: 1 }}
      labelWidth={0}
      multiline={multiline}
      rowsMax={12}
      placeholder={placeholder}
      autoFocus={textInputAutoFocus}
    />
  );
};

export default CustomComposer;
